// extracted by mini-css-extract-plugin
module.exports = {"sun200":"#FEF2DC","grey200":"#E6E6EC","container":"ThankYouBanner_container__inIAV","content":"ThankYouBanner_content__giKsq","image":"ThankYouBanner_image__OFbbX"};